import React, { useState } from 'react';
import { Box, Avatar, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './UserProfile.css';

function UserProfile({ extend }) {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  // Get first letter of email for avatar
  const avatarLetter = currentUser?.email ? currentUser.email[0].toUpperCase() : '?';

  return (
    <Box className={`user-profile ${extend ? 'extended' : 'collapsed'}`}>
      <Avatar
        className="profile-avatar"
      >
        {avatarLetter}
      </Avatar>
      
      {extend && (
        <>
          <Box className="profile-info">
            <Typography variant="body2" className="profile-email">
              {currentUser?.email}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            onClick={() => setOpenLogoutDialog(true)}
            className="logout-button"
          >
            Logout
          </Button>
        </>
      )}

      <Dialog
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        className="logout-dialog"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Confirm Logout
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to log out?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenLogoutDialog(false)} 
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleLogout} 
            variant="contained"
            color="error"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserProfile; 